import { useViewModel } from "@lumora/ui";
import { CATEGORIES } from "../models/QuoteRequest.js";
import type { SampleViewModel } from "../viewmodels/SampleViewModel.js";
import { QuoteTabs } from "./QuoteTabs.js";

/** Dumb View: free sample render form (links only, no uploads). */
export function SamplePage({ viewModel }: { viewModel: SampleViewModel }) {
  const state = useViewModel(viewModel);

  if (state.submitted) {
    return (
      <section className="site-contact t-quote" data-page="sample">
        <h1>Thanks, sample request received</h1>
        <p role="status">We will reply by email within a couple of days, and say if the product is a good fit for a free sample.</p>
      </section>
    );
  }

  return (
    <section className="site-contact t-quote" data-page="sample">
      <p className="t-kicker">Free sample</p>
      <h1>Request a free sample render</h1>
      <QuoteTabs active="sample" />
      <p className="t-section-lead">
        Send a product link and two photo links. We build a watermarked sample for review only. Limited number each month.
      </p>
      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          void viewModel.submit();
        }}
      >
        <label>
          <span>Name</span>
          <input type="text" autoComplete="name" value={state.name} disabled={state.submitting} onChange={(e) => viewModel.setField("name", e.target.value)} />
        </label>
        <label>
          <span>Email</span>
          <input type="email" autoComplete="email" value={state.email} disabled={state.submitting} onChange={(e) => viewModel.setField("email", e.target.value)} />
        </label>
        <label>
          <span>Product link</span>
          <input type="url" inputMode="url" placeholder="https://" value={state.productUrl} disabled={state.submitting} onChange={(e) => viewModel.setField("productUrl", e.target.value)} />
        </label>
        <label>
          <span>Product category</span>
          <select value={state.category} disabled={state.submitting} onChange={(e) => viewModel.setField("category", e.target.value)}>
            <option value="">Choose one</option>
            {CATEGORIES.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </label>
        <label>
          <span>Photo 1 link</span>
          <input type="url" inputMode="url" placeholder="https://" value={state.photoUrl1} disabled={state.submitting} onChange={(e) => viewModel.setField("photoUrl1", e.target.value)} />
        </label>
        <label>
          <span>Photo 2 link</span>
          <input type="url" inputMode="url" placeholder="https://" value={state.photoUrl2} disabled={state.submitting} onChange={(e) => viewModel.setField("photoUrl2", e.target.value)} />
        </label>
        {state.errors.length > 0 ? (
          <ul data-lumora-errors role="alert">
            {state.errors.map((err) => (
              <li key={err}>{err}</li>
            ))}
          </ul>
        ) : null}
        <button type="submit" disabled={state.submitting}>
          {state.submitting ? "Sending..." : "Request free sample"}
        </button>
      </form>
    </section>
  );
}
